<template>
<div>
  <div v-html="content"></div>
  <h1 v-if="files">Descargas</h1>
  <div class="files">
    <div class="file" v-for="file in files" :key="file.id">
      <a :href="file.url">
        {{ file.fileName }} - Descargar
      </a>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    content: String,
    files: Array,
  },
};
</script>

<style lang="scss" scoped>
/deep/ strong {
  font-weight: 500;
}
/deep/ h1 {
  font-size: 2rem;
  margin: 2rem 0 1rem 0;
  font-weight: bold;
}
/deep/ h1:first-child {
  margin-top: 0;
}
/deep/ h2 {
  font-size: 1.6rem;
  margin: 1rem 0;
}
/deep/ h3 {
  font-size: 1.4rem;
  margin: 1rem 0;
}
/deep/ p {
  margin: 1rem 0;
  text-align: justify !important;
  white-space: normal;
}
/deep/ pre {
  padding: 0.7rem 1rem;
  border-radius: 5px;
  background: black;
  color: white;
  font-size: 0.8rem;
  overflow-x: auto;

  /deep/ code {
    display: block;
  }
}
/deep/ * {
  caret-color: currentColor;
  line-height: 1.5;
  font-family: 'Inter';
}
/deep/ p code {
  display: inline-block;
  padding: 0 0.4rem;
  border-radius: 5px;
  font-size: 0.8rem;
  font-weight: bold;
  background: rgba(black, 0.1);
  color: rgba(black, 0.8);
}
/deep/ ul,
/deep/ ol {
  padding-left: 1rem;
}
/deep/ li > p,
/deep/ li > ol,
/deep/ li > ul {
  margin: 0;
}
/deep/ a {
  color: inherit;
}
/deep/ blockquote {
  border-left: 3px solid rgba(black, 0.1);
  color: rgba(black, 0.8);
  padding-left: 0.8rem;
  font-style: italic;

  p {
    margin: 0;
  }
}
/deep/ img {
  max-width: 100%;
  border-radius: 3px;
}
/deep/ table {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
  margin: 0;
  overflow: hidden;
}
/deep/ td, /deep/ th {
  min-width: 1em;
  border: 1px solid rgb(206, 205, 205);
  padding: 3px 5px;
  vertical-align: top;
  box-sizing: border-box;
  position: relative;
}
/deep/ td > * {
  margin-top: 0;
  margin-bottom: 0;
}
/deep/ th > * {
  margin-top: 0;
  margin-bottom: 0;
}
/deep/ th {
  font-weight: bold;
  text-align: left;
}
.file {
  color: #3479e9;
}
</style>
